import { MockDebug } from '@tino-frontend/mocks'
import { billListSnoozeMock } from '@fixtures/apis/bill/list-v3/snooze'
import { billListOverdueMock } from '@fixtures/apis/bill/list-v3/three-overdue'
import { billListAllStatusMock } from '@fixtures/apis/bill/list-v3/all-status'
import { billListStrikethroughMock } from '@fixtures/apis/bill/list-v3/strikethrough'
import { billListLineItemsGroupMock } from '@fixtures/apis/bill/list-v3/line-items-group'
import { genericErrorMock } from '@fixtures/apis/generic-error'

import billDetailClosed from '@fixtures/apis/bill/detail/closed.json'
import billDetailClosedWithDebit from '@fixtures/apis/bill/detail/closed-with-debit.json'
import billDetailWaitingPayment from '@fixtures/apis/bill/detail/waiting-payment.json'
import billDetailWaitingPaymentWithDebit from '@fixtures/apis/bill/detail/waiting-payment-with-debit.json'
import billDetailOpen from '@fixtures/apis/bill/detail/open.json'
import billDetailOpenWithDebit from '@fixtures/apis/bill/detail/open-with-debit.json'
import billDetailOverdue from '@fixtures/apis/bill/detail/overdue.json'
import billDetailEmpty from '@fixtures/apis/bill/detail/empty.json'
import { SnoozeDetailsMock } from '@fixtures/apis/bill/snooze/snooze-details'
import { SnoozeDetailsErrorMock } from '@fixtures/apis/bill/snooze/snooze-details-error'
import { SnoozeSimulationMock } from '@fixtures/apis/bill/snooze/snooze-simulation'
import paySuccess from '@fixtures/apis/bill/pay/success.json'
import paySuccessPix from '@fixtures/apis/bill/pay/success-pix.json'
import payWithoutBoleto from '@fixtures/apis/bill/pay/without-boleto.json'
import payError from '@fixtures/apis/bill/pay/error.json'
import payError500 from '@fixtures/apis/bill/pay/error-500.json'

import saveCSAT from '@fixtures/apis/csat/save-csat'
import { REACT_APP_MERCHANT_BFF_API_URL } from 'constants/envs'
import { billListOpenProcessingMock } from '@fixtures/apis/bill/list-v3/open-processing'
import { billListChargebackMock } from '@fixtures/apis/bill/list-v3/debit-chargeback-aggregate'

// Service: bill
const mockBillListV3 = [
  {
    id: 'mock-bill-snooze-v3',
    title: 'Snooze',
    status: 200,
    data: billListSnoozeMock.source,
  },
  {
    id: 'mock-bill-three-overdue-v3',
    title: 'Three Overdue',
    status: 200,
    data: billListOverdueMock.source,
  },
  {
    id: 'mock-bill-all-status-v3',
    title: 'all status',
    status: 200,
    data: billListAllStatusMock.source,
  },
  {
    id: 'mock-bill-strikethrough-v3',
    title: 'strikethrough',
    status: 200,
    data: billListStrikethroughMock.source,
  },
  {
    id: 'mock-bill-line-items-group-v3',
    title: 'line items group',
    status: 200,
    data: billListLineItemsGroupMock.source,
  },
  {
    id: 'mock-bill-open-processing-v3',
    title: 'aberta em processamento',
    status: 200,
    data: billListOpenProcessingMock.source,
  },
  {
    id: 'mock-bill-chargeback-v4',
    title: ' em chargeback',
    status: 200,
    data: billListChargebackMock.source,
  },
]

const MockDebugBillListV3: MockDebug = {
  title: 'list - V4',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v4/company/:companyId/bills`,
  method: 'get',
  delay: 1000,
  options: mockBillListV3,
}

const MockDebugBillDetail: MockDebug = {
  title: 'Bill detail(deprecated)',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:companyId/home-bill`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-detail-closed',
      title: 'Closed',
      status: 200,
      data: billDetailClosed,
    },
    {
      id: 'mock-detail-closed-with-debit',
      title: 'Closed with debit',
      status: 200,
      data: billDetailClosedWithDebit,
    },
    {
      id: 'mock-detail-waiting-payment',
      title: 'Waiting Payment',
      status: 200,
      data: billDetailWaitingPayment,
    },
    {
      id: 'mock-detail-waiting-payment-with-debit',
      title: 'Waiting Payment - with debit',
      status: 200,
      data: billDetailWaitingPaymentWithDebit,
    },
    {
      id: 'mock-detail-open',
      title: 'Open',
      status: 200,
      data: billDetailOpen,
    },
    {
      id: 'mock-detail-open-with-debit',
      title: 'Open - with debit',
      status: 200,
      data: billDetailOpenWithDebit,
    },
    {
      id: 'mock-detail-overdue',
      title: 'Overdue',
      status: 200,
      data: billDetailOverdue,
    },
    {
      id: 'mock-detail-empty',
      title: 'Empty',
      status: 200,
      data: billDetailEmpty,
    },
  ],
}

const MockDebugBillDetailV2: MockDebug = {
  title: 'Bill detail',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v2/company/:companyId/bill`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-detail-closed',
      title: 'Closed',
      status: 200,
      data: billDetailClosed,
    },
    {
      id: 'mock-detail-closed-with-debit',
      title: 'Closed with debit',
      status: 200,
      data: billDetailClosedWithDebit,
    },
    {
      id: 'mock-detail-waiting-payment',
      title: 'Waiting Payment',
      status: 200,
      data: billDetailWaitingPayment,
    },
    {
      id: 'mock-detail-waiting-payment-with-debit',
      title: 'Waiting Payment - with debit',
      status: 200,
      data: billDetailWaitingPaymentWithDebit,
    },
    {
      id: 'mock-detail-open',
      title: 'Open',
      status: 200,
      data: billDetailOpen,
    },
    {
      id: 'mock-detail-open-with-debit',
      title: 'Open - with debit',
      status: 200,
      data: billDetailOpenWithDebit,
    },
    {
      id: 'mock-detail-overdue',
      title: 'Overdue',
      status: 200,
      data: billDetailOverdue,
    },
    {
      id: 'mock-detail-empty',
      title: 'Empty',
      status: 200,
      data: billDetailEmpty,
    },
  ],
}

const MockDebugBillSnoozeDetails: MockDebug = {
  title: 'snooze - details',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:companyId/financing-debts/:financingDebtsId/snooze`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-bill-snoozeDetails',
      title: 'success',
      status: 200,
      data: SnoozeDetailsMock.source,
    },
    {
      id: 'mock-bill-snoozeDetails-error',
      title: 'error',
      status: 404,
      data: SnoozeDetailsErrorMock.source,
    },
  ],
}

const MockDebugBillSnoozeDetailsById: MockDebug = {
  title: 'snooze - details by id',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:companyId/bills/:billId/snooze`,
  method: 'get',
  delay: 1000,
  options: [
    {
      id: 'mock-bill-snoozeDetailsById',
      title: 'success',
      status: 200,
      data: SnoozeDetailsMock.source,
    },
    {
      id: 'mock-bill-snoozeDetailsById-error',
      title: 'error',
      status: 404,
      data: SnoozeDetailsErrorMock.source,
    },
  ],
}

const MockDebugBillSnoozeSimulate: MockDebug = {
  title: 'snooze - simulation',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:companyId/bills/:billId/snooze-simulation`,
  method: 'post',
  delay: 1000,
  options: [
    {
      id: 'mock-SnoozeSimulate-error-400',
      title: 'error 400',
      status: 400,
      data: genericErrorMock.source,
    },
    {
      id: 'mock-bill-SnoozeSimulate',
      title: 'Simulate',
      status: 200,
      data: SnoozeSimulationMock.source,
    },
  ],
}

const MockDebugBillSnoozeSimulateApprove: MockDebug = {
  title: 'snooze - simulation Approve',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:companyId/snooze-simulations/:financingId/approve`,
  method: 'post',
  delay: 1000,
  options: [
    {
      id: 'mock-bill-SnoozeSimulate-error',
      title: 'Error',
      status: 400,
      data: {},
    },
    {
      id: 'mock-bill-SnoozeSimulate-approve',
      title: 'Simulate Approve',
      status: 200,
      data: {},
    },
  ],
}

const MockDebugBillPay: MockDebug = {
  title: 'pay',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:company_id/bill/:bill_id/pay`,
  method: 'post',
  delay: 1000,
  options: [
    {
      id: 'mock-bill-pay-success',
      title: 'success with boleto',
      status: 200,
      data: paySuccess,
    },
    {
      id: 'mock-bill-pay-success-pix',
      title: 'success with pix',
      status: 200,
      data: paySuccessPix,
    },
    {
      id: 'mock-bill-pay-without-boleto',
      title: 'without boleto',
      status: 200,
      data: payWithoutBoleto,
    },
    {
      id: 'mock-bill-pay-error-404',
      title: 'error - 404',
      status: 404,
      data: payError,
    },
    {
      id: 'mock-bill-pay-error-500',
      title: 'error - 500 - empty response',
      status: 500,
      data: payError500,
    },
  ],
}

const MockDebugBillPayNext: MockDebug = {
  title: 'pay-next-bill',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v2/company/:company_id/pay-next-bill`,
  method: 'post',
  delay: 1000,
  options: [
    {
      id: 'mock-bill-pay-next-success',
      title: 'success with boleto',
      status: 200,
      data: paySuccess,
    },
    {
      id: 'mock-bill-pay-next-success-pix',
      title: 'success with pix',
      status: 200,
      data: paySuccessPix,
    },
    {
      id: 'mock-bill-pay-next-without-boleto',
      title: 'without boleto',
      status: 200,
      data: payWithoutBoleto,
    },
    {
      id: 'mock-bill-pay-next-error-404',
      title: 'error - 404',
      status: 404,
      data: payError,
    },
    {
      id: 'mock-bill-pay-next-error-500',
      title: 'error - 500 - empty response',
      status: 500,
      data: payError500,
    },
  ],
}

const MockAddReferralSeller: MockDebug = {
  title: 'Add referral seller form',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:companyId/supplier-referral`,
  method: 'post',
  delay: 1000,
  options: [
    {
      id: 'mock-add-referral-seller-success',
      title: 'success',
      status: 200,
      data: {},
    },
    {
      id: 'mock-add-referral-seller-error',
      title: 'error',
      status: 500,
      data: genericErrorMock,
    },
  ],
}

const MockSaveCSAT: MockDebug = {
  title: 'CSAT - save form',
  path: `${REACT_APP_MERCHANT_BFF_API_URL}/v1/company/:companyId/bill/:billId/csat`,
  method: 'post',
  delay: 1000,
  options: [
    {
      id: 'mock-bill-save-csat-success',
      title: 'success',
      status: 200,
      data: saveCSAT,
    },
    {
      id: 'mock-bill-save-csat-error-500',
      title: 'error - 500 - empty response',
      status: 500,
      data: payError500,
    },
  ],
}

export const MockDebugBill = [
  MockDebugBillListV3,
  MockDebugBillDetail,
  MockDebugBillDetailV2,
  MockDebugBillSnoozeDetails,
  MockDebugBillSnoozeDetailsById,
  MockDebugBillSnoozeSimulate,
  MockDebugBillSnoozeSimulateApprove,
  MockDebugBillPay,
  MockDebugBillPayNext,
  MockAddReferralSeller,
  MockSaveCSAT,
]
